import OperationsDialogs from './OperationsDialogs';

export default OperationsDialogs;